/*
 * @Author: edconstdchen
 * @Date:   2016-02-26 15:30:16
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-08-16 19:29:49
 */

const assert = require('assert');

const _ = require('lodash');

const utility = require('./helper');

const HTML = require('./image.ejs');

const imageTmpl = _.template(HTML);

/**
 * build image HTML string
 * @param  {Object} imgObj
 * @param  {Object} options
 * @return {String}
 */
function image(imgObj, options) {
  const IMG_MIN_WH = options.minWidth;

  if (imgObj.width < IMG_MIN_WH || imgObj.height < IMG_MIN_WH) {
    console.warn('image too small', imgObj);
    return '';
  }

  const bigConfig = options.big || {};

  assert(bigConfig.width, 'big.width not found');
  assert(bigConfig.height, 'big.height not found');

  const small = imgObj.width < (Number(bigConfig.width) || 0) ||
    imgObj.height < (Number(bigConfig.height) || 0);


  let src = imgObj.sCdnSizedImageUrl;

  if (options.apn === 'wifi') {
    src = imgObj.sCdnOriginalImageUrl;
    if (options.threshold && options.threshold.width && options.threshold.height) {
      src = (imgObj.width >= options.threshold.width || imgObj.height >= options.threshold.height) ?
        imgObj.sCdnSizedImageUrl
        : imgObj.sCdnOriginalImageUrl;
    }
  }

  if (options.https === true && src.substr(0, 5) === 'http:') {
    src = src.substr(5);
  }

  return imageTmpl({
    small,
    src,
    lazy: imgObj.lazy,
    srcHD: src,
    percent: utility.ratioToPercent(imgObj.height / imgObj.width),
    width: imgObj.width,
    height: imgObj.height
  });
}
module.exports = image;



// WEBPACK FOOTER //
// ./src/HTMLTag/image.js